module.exports = __webpack_public_path__ + "static/media/arrow-drop-down-right.03a7fb4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-drop-down-right.svg
// module id = 1249
// module chunks = 1